<template>
  <b-modal id="edit_address_modal" ref="edit_address_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <!-- Different modal header depending on type note being left -->
        <h1>
          <i class="fas fa-map-marked-alt"></i>
          <span>Edit Address</span>
        </h1>
        <p id="mh-info">Edit a new address for {{ $store.state.addresses.company_name }}</p>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <ValidationObserver ref="editAddressForm" slim>
      <form role="form" @submit.prevent="update_address()">
        <div class="row" v-if="notEmptyObject(address)">
          <div class="col-12 form-group">
            <validationProvider rules="required" v-slot="{errors, classes}" name="Address Type" tag="div">
              <label class="form-label" for="address_type">Address Type</label>
              <multiselect v-model="address.address_type" id="address_type" name="address_type" placeholder="" class="requiredField"
                           :class="[classes, address.address_type === 'Registered Office' || address.address_type === 'Head Office' ? 'disabled' : '']"
                           :options="ms_opts.address_types" :disabled="address.address_type.value === 'Registered Office' || address.address_type.value === 'Head Office'"
                           label="value" track-by="id"></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </validationProvider>
          </div>

          <div class="col-12 form-group">
            <label class="form-label" for="contact_address">Address (Google Maps Search)</label>
            <GmapAutocomplete id="contact_address" name="contact_address" class="form-input input" placeholder="" @place_changed="set_address"
                              :value="address.full" @input.native="watch_address" @keypress.enter="$event.preventDefault()"></GmapAutocomplete>
          </div>
          <div class="col-6 form-group">
            <label class="form-label" for="personal_building">Building</label>
            <input type="text" v-model="address.building" id="personal_building" name="personal_building" class="form-input">
          </div>
          <div class="col-6 form-group">
            <label class="form-label" for="personal_street">Street</label>
            <input type="text" v-model="address.street" id="personal_street" name="personal_street" class="form-input">
          </div>
          <div class="col-6 form-group">
            <label class="form-label" for="personal_locality">Locality</label>
            <input type="text" v-model="address.locality" id="personal_locality" name="personal_locality" class="form-input">
          </div>
          <div class="col-6 form-group">
            <label class="form-label" for="personal_city_town">City / Town</label>
            <input type="text" v-model="address.city_town" id="personal_city_town" name="personal_city_town" class="form-input">
          </div>
          <div class="col-6 form-group">
            <label class="form-label" for="personal_county">County</label>
            <input type="text" v-model="address.county" id="personal_county" name="personal_county" class="form-input">
          </div>
          <div class="col-6 form-group">
            <label class="form-label" for="personal_postcode">Postcode</label>
            <input type="text" v-model="address.postcode" id="personal_postcode" name="personal_postcode" class="form-input">
          </div>
          <div class="col-12 form-group" v-if="no_address">
            <div class="vvERROR">You must enter an address</div>
          </div>
          <div class="col-12">
            <div class="float-right">
              <button type="submit" class="btn orcaBtn">UPDATE and CLOSE</button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>

  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import Vue from "vue";
import * as GmapVue from 'gmap-vue'

Vue.use(GmapVue, {
  load: {
    key: process.env.MIX_API_GMAPS_KEY, // LIVE
    libraries: 'places',
    region: 'GB'
  }
});

export default {
  name: "edit_address",
  components: {
    Multiselect
  },
  data() {
    return {
      ms_opts: {
        address_types: this.$store.state.crm_options.company_address_type
      },

      address: {},

      no_address: false
    }
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'contact_info/address/' + this.$store.state.addresses.id).then(address => this.address = address.data);
    axios.get(this.crmApiPath + 'contact_info/address/company/' + this.$store.state.addresses.company_id + '/address_types').then(add_types => {
      if (add_types.data.includes('Registered Office')) {
        this.ms_opts.address_types = this.ms_opts.address_types.filter(function (value, index, arr) {
          return value !== 'Registered Office';
        })
      }
      if (add_types.data.includes('Head Office')) {
        this.ms_opts.address_types = this.ms_opts.address_types.filter(function (value, index, arr) {
          return value !== 'Head Office';
        })
      }
    })
  },
  methods: {
    set_address(place) {
      let address = this.set_google_address(place);
      // set all address variables
      this.address.building = address.building;
      this.address.street = address.street;
      this.address.locality = address.locality;
      this.address.city_town = address.city_town;
      this.address.county = address.county;
      this.address.postcode = address.postcode;
    },
    watch_address(place) {
      if (place.path[0].value === '') {
        this.address.full = null;
        this.address.building = null;
        this.address.street = null;
        this.address.locality = null;
        this.address.city_town = null;
        this.address.county = null;
        this.address.postcode = null;
      }
    },
    hideModal() {
      this.$refs.edit_address_modal.hide();
      this.$store.commit('HIDE_ADDRESS_MODALS');
    },
    update_address() {
      this.$refs.editAddressForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.editAddressForm);
        }
        else {
          this.address.log_by_type = 'App\\Models\\Users\\User';
          this.address.log_by_id = this.$store.state.auth.me.id;

          if (!(this.address.building === null && this.address.street === null && this.address.locality === null && this.address.city_town === null && this.address.county === null &&
              this.address.postcode === null)) {

            this.address.contact_info_model_type = 'App\\Models\\Contact_Info\\Address';
            this.$store.commit('SET_UPDATE_COMPANY_ID', this.address.client_id);

            axios.patch(this.crmApiPath + 'contact_info/address/' + this.address.id, this.address).then(() => {
              this.$nextTick(() => {
                this.$snotify.success('Address updated : ' + this.address.full);
                this.$bus.$emit('logs::reload', {action: true});
                this.$bus.$emit('address::reload', {action: true});
                this.hideModal();
                this.$bus.$emit('table::reload', {table: 'all_companies', type: 'update'});
              })
            })
          }
          else {
            this.no_address = true;
          }
        }
      });
    }
  },
  watch: {
    'address.building'(building) {
      this.address.full = this.calc_nice_address(building, this.address.street, this.address.locality, this.address.city_town, this.address.county, this.address.postcode);
    },
    'address.street'(street) {
      this.address.full = this.calc_nice_address(this.address.building, street, this.address.locality, this.address.city_town, this.address.county, this.address.postcode);
    },
    'address.locality'(locality) {
      this.address.full = this.calc_nice_address(this.address.building, this.address.street, locality, this.address.city_town, this.address.county, this.address.postcode);
    },
    'address.city_town'(city_town) {
      this.address.full = this.calc_nice_address(this.address.building, this.address.street, this.address.locality, city_town, this.address.county, this.address.postcode);
    },
    'address.county'(county) {
      this.address.full = this.calc_nice_address(this.address.building, this.address.street, this.address.locality, this.address.city_town, county, this.address.postcode);
    },
    'address.postcode'(postcode) {
      this.address.full = this.calc_nice_address(this.address.building, this.address.street, this.address.locality, this.address.city_town, this.address.county, postcode);
    },
  }
}
</script>
